<template>
    <v-card>
      <div>
        <v-img
          :src="empresa.url_imagem_posto ? empresa.url_imagem_posto : require('@/assets/posto-default.png')"
          aspect-ratio="2.75"
        />
      </div>
      <v-card>
        <v-bottom-nav
          :active.sync="teste"
          color="primary"
          :value="true"
          dark
          shift
        >
          <v-btn dark @click="step = 1">
            <span>Empresa</span>
            <v-icon>business</v-icon>
          </v-btn>

          <v-btn dark @click="step = 2">
            <span>Administrador</span>
            <v-icon>account_circle</v-icon>
          </v-btn>

          <v-btn dark @click="step = 3">
            <span>Endereço</span>
            <v-icon>place</v-icon>
          </v-btn>

          <v-btn dark @click="step = 4">
            <span>Contrato</span>
            <v-icon>description</v-icon>
          </v-btn>

          <v-btn dark @click="step = 5">
            <span>Automação</span>
            <v-icon>android</v-icon>
          </v-btn>

          <v-btn dark @click="step = 6">
            <span>Sindicato</span>
            <v-icon>handshake</v-icon>
          </v-btn>

          <v-btn dark @click="step = 7" v-if="empresa && ![3, 8].includes(empresa.tipo_empresa)">
            <span>Convênio</span>
            <v-icon>apps</v-icon>
          </v-btn>
        </v-bottom-nav>
      </v-card>
      <v-card-text v-if="empresa">
          <v-stepper v-model="step" style="box-shadow: none;">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <v-layout row wrap justify-space-around fill-height>
                  <v-flex xs12 style="font-size: 1.5em" class="text-xs-center pt-2 pb-2">Editar Empresa</v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                        label="Razão Social"
                        v-model="empresa.razao_social"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                        label="Nome Fantasia"
                        v-model="empresa.nome_fantasia"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm11>
                    <v-text-field
                        readonly
                        disabled
                        label="CNPJ"
                        v-model="empresa.cnpj"
                        mask="##.###.###/####-##"
                        class="text-xs-center"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                        mask="(##)#####-####"
                        label="Contato (1)"
                        v-model="empresa.contato1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                        mask="(##)#####-####"
                        label="Contato (2)"
                        v-model="empresa.contato2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm11>
                    <v-text-field
                        mask="(##)#####-####"
                        label="Contato (3)"
                        v-model="empresa.contato3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm11>
                    <v-select
                        label="Tipo de empresa"
                        v-model="empresa.tipo_empresa"
                        :items="tipo_empresa"
                    ></v-select>
                  </v-flex>
                  <template v-if="empresa.tipo_empresa === 4 || empresa.tipo_empresa === 5 || empresa.tipo_empresa === 6">
                    <v-flex xs11 align-self-center>
                      <v-select
                        v-model="empresa.categoria"
                        :items="categorias"
                        label="Categoria de Atuação"
                      />
                    </v-flex>
                    <v-flex xs11 align-self-center>
                      <v-select
                        v-model="empresa.subcategorias"
                        :items="subcategorias.filter(sc => {
                          const categoriaCorrespondente = sc.categoria === empresa.categoria || empresa.categoria === 9
                          const servicoCorrespondente = (empresa.tipo_empresa === 5 && sc.servico || empresa.tipo_empresa === 4 && !sc.servico) || (empresa.tipo_empresa === 6)
                          return categoriaCorrespondente && servicoCorrespondente
                        }
                        )"
                        label="Subcategoria de Atuação"
                        chips
                        multiple
                      />
                    </v-flex>
                  </template>
                  <v-layout column full-width>
                    <v-btn
                      v-if="empresa.tipo_empresa === 2"
                      round
                      outline
                      block
                      @click="empresa.permitir_usuarios = !empresa.permitir_usuarios"
                      :color="empresa.permitir_usuarios ? 'red darken-2' : 'green darken-2'"
                    >
                      {{
                        empresa.permitir_usuarios ?
                        'Desativar leilão para usuarios'
                        :
                        'Ativar leilão para usuarios'
                      }}
                    </v-btn>
                    <v-btn
                      slot="activator"
                      round
                      outline
                      block
                      @click="empresa.is_white_label = !empresa.is_white_label"
                      :color="empresa.is_white_label ? 'red darken-2' : 'green darken-2'"
                    >
                      {{
                        empresa.is_white_label ?
                        'Desativar White Label'
                        :
                        'Ativar White Label'
                      }}
                    </v-btn>
                    <v-btn
                      :disabled="!empresa.is_white_label"
                      round
                      outline
                      block
                      @click="empresa.is_simultaneo = !empresa.is_simultaneo"
                      :color="empresa.is_simultaneo ? 'red darken-2' : 'green darken-2'"
                    >
                      {{
                        empresa.is_simultaneo ?
                        'Desativar uso simultâneo'
                        :
                        'Ativar uso simultâneo'
                      }}
                    </v-btn>
                  </v-layout>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <v-layout row wrap justify-space-around fill-height>
                  <v-flex xs12 style="font-size: 1.5em" class="text-xs-center pt-2 pb-2">Editar Administrador</v-flex>
                  <v-flex xs5>
                        <v-text-field
                            label="Nome"
                            v-model="empresa.administrador.nome"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                        <v-text-field
                            label="Sobrenome"
                            v-model="empresa.administrador.sobrenome"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5>
                    <v-text-field
                        mask="(##) # ####-####"
                        label="Telefone"
                        v-model="empresa.administrador.telefone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                        mask="###.###.###-##"
                        label="CPF"
                        v-model="empresa.administrador.cpf"
                    ></v-text-field>
                  </v-flex>
                    <v-flex xs11>
                        <v-text-field
                            disabled
                            label="Email do Representante"
                            v-model="empresa.administrador.email"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && empresa.administrador && verificacaoTelefone.pessoa.id_pessoa !== empresa.administrador.id_pessoa)">
                    <v-card class="ma-2" elevation="4">
                      <v-card-title class="justify-center">
                        <h4
                          v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                          class="text-xs-center error--text"
                        >
                          Esse telefone já foi cadastrado
                        </h4>
                      </v-card-title>
                      <v-card-text>
                        <v-flex
                          class="error--text"
                          v-if="verificacaoTelefone.quantidade > 0"
                        >
                          {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                        </v-flex>
                        <v-flex
                          class="error--text"
                          v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                        >
                          IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                            {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                          </span>
                        </v-flex>
                        <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                          <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                          <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                          <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                          <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                          <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="3" class="pa-0 ma-0">
                <v-layout row wrap justify-space-around fill-height>
                  <v-flex style="font-size: 1.5em" xs12 class="text-xs-center pt-2 pb-2">Editar Endereço</v-flex>
                  <v-flex xs8>
                      <v-text-field
                          label="Logradouro"
                          v-model="empresa.endereco.logradouro"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                      <v-text-field
                          label="Número"
                          v-model="empresa.endereco.numero"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          label="Cidade"
                          v-model="empresa.endereco.cidade"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          label="Bairro"
                          v-model="empresa.endereco.bairro"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                      <v-text-field
                          label="Estado"
                          v-model="empresa.endereco.estado"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                      <v-text-field
                          label="País"
                          v-model="empresa.endereco.pais"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                          label="CEP"
                          v-model="empresa.endereco.cep"
                          mask="#####-###"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="4" class="pa-0 ma-0">
                <v-layout row wrap justify-space-around fill-height>
                  <v-flex style="font-size: 1.5em" xs12 class="text-xs-center pt-2 pb-2">Editar Contrato</v-flex>
                  <v-flex>
                    <h2 style="text-align: center;">Dados da Fatura</h2>
                  </v-flex>
                <v-flex xs12 class="pb-0">
                  <v-menu
                    transition="scale-transition"
                    offset-y
                    full-width
                    lazy
                    max-width="290px"
                    min-width="290px"
                    :close-on-content-click="false"
                    v-model="data_faturamento"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="data_fatura_formated"
                        outline
                        v-on="on"
                        label="Data do proximo faturamento"
                        required
                        :rules="[
                              v => !!v || 'O campo é obrigatório'
                            ]"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="data_fatura"
                        no-title
                        locale="pt-br"
                        :allowed-dates="(date) => {
                          return Date.parse(date) > today
                        }"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        color="green darken-1"
                        class="caption font-weight-medium"
                        @click="data_faturamento = false"
                      >FECHAR</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <h5 v-if="data_fatura_formated">
                    Em {{data_fatura_formated}} será gerado uma fatura cobrando a empresa {{empresa.nome_fantasia}}.
                  </h5>
                </v-flex>
                <v-flex xs12 class="mb-3">
                  <v-switch
                    v-model="empresa.gerar_boleto"
                    label="Gerar boleto Efi"
                    color="primary"
                  ></v-switch>
                  <h5>
                    {{
                      empresa.gerar_boleto ?
                      'Será gerado um boleto e será enviado para o e-mail da empresa.'
                      :
                      'Não será gerado boleto. Você precisar gerar o boleto de acordo com as informações da fatura.'
                    }}
                  </h5>
                </v-flex>
                <v-flex xs12 class="mb-3">
              <v-switch
                v-model="empresa.baixa_automatica"
                label="Dar baixar automaticamente"
                color="primary"
              ></v-switch>
              <h5>
                {{
                  empresa.baixa_automatica ?
                  'Será dado baixar automaticamente nas compras pós pagas que foram realizadas a 5 dias ou mais..'
                  :
                  'Não será dado baixar automaticamente nas compras pós pagas.'
                }}
              </h5>
                </v-flex>
                  <v-divider></v-divider>
                  <v-flex xs12>
                    <v-switch
                      v-model="tem_mensalidade"
                      label="Tem assinatura"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="tem_mensalidade">
                    <v-text-field
                      v-model.lazy="valor_mensalidade"
                      v-money="money"
                      v-if="rendering"
                      prefix="R$"
                      outline
                      label="Valor da assinatura"
                      hide-details
                    ></v-text-field>
                    <h5>Será combrado R$ {{empresa.valor_assinatura}} todos os meses da empresa {{empresa.nome_fantasia}}</h5>
                  </v-flex>
                  <v-flex xs12 v-if="empresa.tipo_empresa === 1">
                    <v-switch
                      v-model="taxa_por_veiculo"
                      label="Tem taxa por veículo"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="taxa_por_veiculo">
                    <v-text-field
                      v-model.lazy="valor_taxa_veiculo"
                      v-money="money"
                      v-if="rendering"
                      prefix="R$"
                      outline
                      label="Taxa por veículo"
                      hide-details
                    ></v-text-field>
                    <h5>Será combrado R$ {{empresa.taxa_por_veiculo}} por veículo da empresa {{empresa.nome_fantasia}}</h5>
                  </v-flex>
                  <v-flex xs12 v-if="empresa.tipo_empresa === 1">
                    <v-switch
                      v-model="taxa_abastecimeto"
                      label="Tem percentual em cima do abastecimento"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="taxa_abastecimeto">
                    <v-text-field
                      v-model="empresa.taxa_por_abastecimento"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por abastecimetno"
                      hide-details
                      type="number"
                    ></v-text-field>
                    <h5>Será combrado {{empresa.taxa_por_abastecimento}}% por abastecimento da empresa {{empresa.nome_fantasia}}</h5>
                  </v-flex>
                  <v-flex xs12 v-if="empresa.tipo_empresa === 1">
                    <v-switch
                      v-model="taxa_abastecimeto_carteira"
                      label="Tem percentual em cima do abastecimento com a carteira"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="taxa_abastecimeto_carteira">
                    <v-text-field
                      v-model="empresa.taxa_por_abastecimento_carteira"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por abastecimetno da carteira"
                      hide-details
                      type="number"
                    ></v-text-field>
                    <h5>Será combrado {{empresa.taxa_por_abastecimento_carteira}}% por abastecimento da empresa {{empresa.nome_fantasia}}</h5>
                  </v-flex>

                  <v-flex xs12 v-if="[4, 5, 6].includes(empresa.tipo_empresa)">
                    <v-switch
                      v-model="tem_taxa_recebimento_empresa"
                      label="Tem taxa para as vendas para empresa"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="tem_taxa_recebimento_empresa">
                    <v-text-field
                      v-model="empresa.taxa_recebimento_empresa"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por venda para empresas"
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="[4, 5, 6].includes(empresa.tipo_empresa)">
                    <v-switch
                      v-model="tem_taxa_recebimento_cliente"
                      label="Tem taxa para as vendas para clientes"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="tem_taxa_recebimento_cliente">
                    <v-text-field
                      v-model="empresa.taxa_recebimento_cliente"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por venda para clientes"
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="[4, 5, 6].includes(empresa.tipo_empresa)">
                    <v-switch
                      v-model="tem_taxa_recebimento_carteira_empresa"
                      label="Tem taxa para as vendas pela carteira para empresa"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="tem_taxa_recebimento_carteira_empresa">
                    <v-text-field
                      v-model="empresa.taxa_recebimento_carteira_empresa"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por venda pela carteira para empresas"
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="[4, 5, 6].includes(empresa.tipo_empresa)">
                    <v-switch
                      v-model="tem_taxa_recebimento_carteira_cliente"
                      label="Tem taxa para as vendas pela carteira para clientes"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="tem_taxa_recebimento_carteira_cliente">
                    <v-text-field
                      v-model="empresa.taxa_recebimento_carteira_cliente"
                      v-if="rendering"
                      suffix="%"
                      outline
                      label="Taxa por venda pela carteira para clientes"
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="mt-4">
                    <v-spacer></v-spacer>
                    <v-divider></v-divider>
                    <h2 style="text-align: center;" class="mt-4">Programas</h2>
                  </v-flex>
                  <v-flex xs12 v-if="empresa.programa_doacao">
                  <v-switch
                    v-model="empresa.programa_doacao.ativo_apetrus"
                    label="Programa de doação"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="empresa.programa_doacao && empresa.programa_doacao.ativo_apetrus">
                  <v-text-field
                    v-model.lazy="valor_doacao"
                    v-if="rendering"
                    outline
                    label="Valor Doacão"
                    hide-details
                    v-money="money"
                  ></v-text-field>
                  <h5>Em cada compra será doado {{valor_doacao}} para instituição</h5>
                </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step='5' class="pa-0">
                <v-layout column wrap>
                  <v-flex xs12 class="mb-2">
                    <h3 style="text-align: center;" class="mb-2">Selecione uma Integradora</h3>
                    <v-select
                      :items="empresas_integradora"
                      item-text="nome_fantasia"
                      item-value="cnpj"
                      solo
                      clearable
                      placeholder="Clique para selecionar uma Integradora"
                      :loading="loading"
                      @change="selecionarIntegradora()"
                      outline
                      single-line
                      v-model="integradora_cnpj"
                    />
                  </v-flex>
                  <v-flex xs12 class="mb-2">
                    <h3 style="text-align: center;" class="mb-2">Selecione uma Empresa de Automação</h3>
                    <v-select
                      :items="empresas_automacao"
                      item-text="nome_fantasia"
                      item-value="cnpj"
                      solo
                      clearable
                      placeholder="Clique para selecionar uma Automação"
                      :loading="loading"
                      @change="selecionarAutomacao()"
                      outline
                      single-line
                      v-model="cnpj_empresa_automacao"
                    />
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step='6' class="pa-0">
                <h3 style="text-align: center;" class="mb-2">Selecione um Sindicato</h3>
                <v-select
                  :items="sindicatos"
                  item-text="nome"
                  item-value="id_rede"
                  solo
                  clearable
                  placeholder="Clique para selecionar um Sindicato"
                  :loading="loading"
                  @change="selecionarSindicato()"
                  outline
                  single-line
                  v-model="sindicato"
                />
              </v-stepper-content>
              <v-stepper-content step='7' class="pa-0">
                <v-layout justify-center>
                  <v-checkbox
                    v-model="empresa.convenio_apetrus"
                    label="Permitir Convênio no App Apetrus?"
                    color="primary"
                    hide-details
                    class="mb-3"
                  ></v-checkbox>
                </v-layout>
                <v-divider class="mb-3"></v-divider>
                <h3 style="text-align: center;" class="mb-2 mt-2">Aplicativos Parceiros com Convênio</h3>
                <v-select
                  :items="projetosFirebase"
                  item-text="nome"
                  item-value="id"
                  solo
                  multiple
                  chips
                  clearable
                  placeholder="Selecione os Aplicativos com Convênio"
                  :loading="loading"
                  outline
                  v-model="empresa.convenio_app"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-btn flat block @click="$emit('fechar')">Fechar</v-btn>
        <v-btn
          flat
          block
          color="primary"
          :disabled="step===5"
          @click="editarEmpresa"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>

import { VMoney } from 'v-money'

export default {
  props: ['empresa_selecionada'],
  directives: { money: VMoney },
  data () {
    let todayDate = new Date().toISOString().substr(0, 10)
    return {
      today: Date.parse(todayDate),
      categorias: [
      { text: 'Alimentação e Bebidas', value: 1 },
      { text: 'Automóveis e Peças Automotivas', value: 2 },
      { text: 'Construção e Imóveis', value: 3 },
      { text: 'Design e Criatividade', value: 4 },
      { text: 'Moda e Estilo', value: 5 },
      { text: 'Saúde e Bem-Estar', value: 6 },
      { text: 'Beleza e Estética', value: 7 },
      { text: 'Educação e Treinamento', value: 8 },
      { text: 'Outra', value: 9 }
    ],
    subcategorias: [
        // Alimentação e Bebidas
        { text: 'Restaurante', value: 1, categoria: 1, servico: false },
        { text: 'Lanchonete', value: 2, categoria: 1, servico: false },
        { text: 'Pizzaria', value: 3, categoria: 1, servico: false },
        { text: 'Bar', value: 4, categoria: 1, servico: false },
        { text: 'Buffet', value: 5, categoria: 1, servico: true },
        { text: 'Supermercado', value: 6, categoria: 1, servico: false },
        { text: 'Venda de Água Mineral', value: 7, categoria: 1, servico: false },
        { text: 'Padaria', value: 8, categoria: 1, servico: false },

        // Automóveis e Peças Automotivas
        { text: 'Auto Peças', value: 9, categoria: 2, servico: false },
        { text: 'Oficina', value: 10, categoria: 2, servico: true },
        { text: 'Concessionária', value: 11, categoria: 2, servico: false },
        { text: 'Transportadora', value: 12, categoria: 2, servico: true },
        { text: 'Lava Jato', value: 13, categoria: 2, servico: true },
        { text: 'Locação', value: 14, categoria: 2, servico: true },
        { text: 'Auto Escola', value: 15, categoria: 2, servico: true },
        { text: 'Equipadora', value: 16, categoria: 2, servico: true },

        // Construção e Imóveis
        { text: 'Material de Construção', value: 17, categoria: 3, servico: false },
        { text: 'Construtora', value: 18, categoria: 3, servico: true },
        { text: 'Metalurgica', value: 19, categoria: 3, servico: true },
        { text: 'Madeireira', value: 20, categoria: 3, servico: false },
        { text: 'Portão Automático', value: 21, categoria: 3, servico: false },
        { text: 'Vidraçarias', value: 22, categoria: 3, servico: true },
        { text: 'Engenharia', value: 23, categoria: 3, servico: true },
        { text: 'Serralharia', value: 24, categoria: 3, servico: true },
        { text: 'Corretagem e Consultoria Imobiliária', value: 25, categoria: 3, servico: true },
        { text: 'Desenvolvimento Imobiliário', value: 26, categoria: 3, servico: true },
        { text: 'Gestão de Propriedades', value: 27, categoria: 3, servico: true },
        { text: 'Construção Residencial', value: 28, categoria: 3, servico: true },
        { text: 'Construção Comercial', value: 29, categoria: 3, servico: true },
        { text: 'Serviços de Manutenção Predial', value: 30, categoria: 3, servico: true },
        { text: 'Investimento Imobiliário', value: 31, categoria: 3, servico: true },
        { text: 'Avaliação de Propriedades', value: 32, categoria: 3, servico: true },
        { text: 'Empreendimentos Sustentáveis', value: 33, categoria: 3, servico: false },
        { text: 'Arquitetura e Design de Interiores', value: 34, categoria: 3, servico: true },

        // Design e Criatividade
        { text: 'Design Gráfico', value: 35, categoria: 4, servico: true },
        { text: 'Design de Produto', value: 36, categoria: 4, servico: true },
        { text: 'Design de Interiores', value: 37, categoria: 4, servico: true },
        { text: 'Design de Moda', value: 38, categoria: 4, servico: true },
        { text: 'Arquitetura', value: 39, categoria: 4, servico: true },
        { text: 'Design de Mídia', value: 40, categoria: 4, servico: true },
        { text: 'Ilustração e Arte Gráfica', value: 41, categoria: 4, servico: true },
        { text: 'Web Design e Desenvolvimento', value: 42, categoria: 4, servico: true },

        // Moda e Estilo
        { text: 'Roupa Feminina', value: 42, categoria: 5, servico: false },
        { text: 'Roupa Unissex', value: 43, categoria: 5, servico: false },
        { text: 'Roupa Masculina', value: 44, categoria: 5, servico: false },
        { text: 'Roupa Infantil', value: 45, categoria: 5, servico: false },
        { text: 'Ótica', value: 46, categoria: 5, servico: false },
        { text: 'Pronta Entrega', value: 47, categoria: 5, servico: false },
        { text: 'Calçados e Bolsas', value: 48, categoria: 5, servico: false },
        { text: 'Conserto de Roupa', value: 49, categoria: 5, servico: false },
        { text: 'Atelier', value: 50, categoria: 5, servico: true },
        { text: 'Acessórios', value: 51, categoria: 5, servico: false },
        { text: 'Armarinho', value: 52, categoria: 5, servico: false }, // verificar
        { text: 'Roupas Esportivas e Ativewear', value: 53, categoria: 5, servico: false },

        // Saúde e Bem-Estar
        { text: 'Clínica', value: 53, categoria: 6, servico: true }, // verificar
        { text: 'Farmácia', value: 54, categoria: 6, servico: false },
        { text: 'Plano de Saúde', value: 55, categoria: 6, servico: false },
        { text: 'Serviços Médicos', value: 56, categoria: 6, servico: true },
        { text: 'Serviços Odontológico', value: 57, categoria: 6, servico: true },
        { text: 'Laboratório', value: 58, categoria: 6, servico: true },
        { text: 'Posto de Saúde', value: 59, categoria: 6, servico: true },
        { text: 'Nutrição', value: 60, categoria: 6, servico: true },
        { text: 'Farmácia de Manipulação', value: 61, categoria: 6, servico: false },
        { text: 'Fitness', value: 62, categoria: 6, servico: true },

        // Beleza e Estética
        { text: 'Salão de Beleza', value: 63, categoria: 7, servico: true },
        { text: 'Depilação', value: 64, categoria: 7, servico: true },
        { text: 'Perfumaria', value: 65, categoria: 7, servico: false },
        { text: 'Cosméticos', value: 66, categoria: 7, servico: false },
        { text: 'Massagem', value: 67, categoria: 7, servico: true },
        { text: 'Barbearia', value: 68, categoria: 7, servico: true },
        { text: 'Tatuagem', value: 69, categoria: 7, servico: true },
        { text: 'Piercing', value: 70, categoria: 7, servico: true },
        { text: 'Esmalteria', value: 71, categoria: 7, servico: false },
        { text: 'Bronzeamento', value: 72, categoria: 7, servico: true },
        { text: 'Maquiagem', value: 73, categoria: 7, servico: false },
        { text: 'Cuidados com a Pele', value: 74, categoria: 7, servico: true },
        { text: 'Manicure e Pedicure', value: 75, categoria: 7, servico: true },
        { text: 'Spas de Beleza', value: 76, categoria: 7, servico: true },
        { text: 'Cirurgia Plástica Estética', value: 77, categoria: 7, servico: true },
        { text: 'Design de Sobrancelhas e Cílios', value: 77, categoria: 7, servico: true },

        // Educação e Treinamento
        { text: 'Instituições Educacional', value: 78, categoria: 8, servico: true },
        { text: 'Treinamento Corporativo', value: 79, categoria: 8, servico: true },
        { text: 'Educação à Distância', value: 79, categoria: 8, servico: true },
        { text: 'Cursos de Idiomas', value: 80, categoria: 8, servico: true },
        { text: 'Cursos Técnicos', value: 81, categoria: 8, servico: true },
        { text: 'Educação Especial', value: 82, categoria: 8, servico: true },
        { text: 'Faculdade', value: 83, categoria: 8, servico: true },
        { text: 'Livrarias', value: 84, categoria: 8, servico: false },
        { text: 'Transporte Escolar', value: 85, categoria: 8, servico: true },
        { text: 'Escola Ensino Fundamental', value: 86, categoria: 8, servico: true },
        { text: 'Escola Ensino Infantil', value: 87, categoria: 8, servico: true },
        { text: 'Escola Ensino Médio', value: 88, categoria: 8, servico: true },

        // Outros
        { text: 'Lavanderia', value: 89, categoria: 9, servico: true },
        { text: 'Serigrafia', value: 90, categoria: 9, servico: true },
        { text: 'Assistencia Tecnica', value: 91, categoria: 9, servico: true },
        { text: 'Contabilidade', value: 92, categoria: 9, servico: true },
        { text: 'Associação', value: 93, categoria: 9, servico: true },
        { text: 'Eletrica', value: 94, categoria: 9, servico: true },
        { text: 'Eletrônica', value: 95, categoria: 9, servico: true },
        { text: 'Sistema de Segurança', value: 96, categoria: 9, servico: true },
        { text: 'Venda de Gás de Cozinha', value: 97, categoria: 9, servico: false }
      ],
      data_faturamento: false,
      data_fatura: null,
      data_fatura_formated: null,
      gerar_boleto: false,
      taxa_abastecimeto: false,
      taxa_abastecimeto_carteira: false,
      tem_taxa_recebimento_empresa: false,
      tem_taxa_recebimento_carteira_empresa: false,
      tem_taxa_recebimento_cliente: false,
      tem_taxa_recebimento_carteira_cliente: false,
      taxa_por_veiculo: false,
      valor_taxa_veiculo: null,
      tem_mensalidade: false,
      valor_mensalidade: null,
      rendering: true,
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      },
      step: 1,
      teste: 0,
      valor_doacao: null,
      empresas_integradora: [],
      sindicato: undefined,
      sindicatos: [],
      projetosFirebase: [],
      integradora_cnpj: undefined,
      empresas_automacao: [],
      cnpj_empresa_automacao: undefined,
      tipo_empresa: [
        { text: 'Controle de Frota', value: 1 },
        { text: 'Revendedora de veículos', value: 2 },
        { text: 'Automação', value: 3 },
        { text: 'Venda de Produtos', value: 4 },
        { text: 'Prestação de Serviços', value: 5 },
        { text: 'Venda de Produtos e Serviços', value: 6 },
        { text: 'Instituição Beneficente', value: 7 },
        { text: 'Integradora', value: 8 },
        { text: 'Sindicato', value: 9 }
      ],
      empresa: {
        taxa_por_abastecimento: null,
        taxa_por_abastecimento_carteira: null,
        taxa_por_veiculo: null,
        valor_assinatura: null,
        taxa_recebimento_empresa: null,
        taxa_recebimento_cliente: null,
        taxa_recebimento_carteira_empresa: null,
        taxa_recebimento_carteira_cliente: null,
        baixa_automatica: false,
        administrador: { telefone: '', id_pessoa: null },
        endereco: {},
        programa_doacao: {},
        is_white_label: false,
        permitir_usuarios: true
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    valor_taxa_veiculo (val) {
      if (val !== undefined && val !== null) {
        this.empresa.taxa_por_veiculo = val.replace(',', '.')
      }
    },
    valor_mensalidade (val) {
      if (val !== undefined && val !== null) {
        this.empresa.valor_assinatura = val.replace(',', '.')
      }
    },
    valor_doacao (val) {
      if (val !== undefined && val !== null) {
        this.empresa.programa_doacao.valor_doacao = val.replace(',', '.')
      }
    },
    taxa_abastecimeto (val) {
      if (!val) {
        this.empresa.taxa_por_abastecimento = null
      }
    },
    taxa_abastecimeto_carteira (val) {
      if (!val) {
        this.empresa.taxa_por_abastecimento_carteira = null
      }
    },
    taxa_por_veiculo (val) {
      if (!val) {
        this.empresa.taxa_por_veiculo = null
        this.valor_taxa_veiculo = null
      }
    },
    tem_mensalidade (val) {
      if (!val) {
        this.empresa.valor_assinatura = null
        this.valor_mensalidade = null
      }
    },
    tem_taxa_recebimento_cliente (val) {
      if (!val) this.empresa.taxa_recebimento_cliente = null
    },
    tem_taxa_recebimento_empresa (val) {
      if (!val) this.empresa.taxa_recebimento_empresa = null
    },
    tem_taxa_recebimento_carteira_cliente (val) {
      if (!val) this.empresa.taxa_recebimento_carteira_cliente = null
    },
    tem_taxa_recebimento_carteira_empresa (val) {
      if (!val) this.empresa.taxa_recebimento_carteira_empresa = null
    },
    data_fatura (val) {
      this.empresa.data_ultimo_faturamento_apetrus = val
      this.data_faturamento = false
      if (val) {
        this.data_fatura_formated = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.data_fatura_formated = null
      }
    },
    'empresa.administrador.telefone' (val) {
     if (val && val.length === 11) {
      this.verificarTelefone()
     } else {
      this.verificacaoTelefone.pessoa = undefined
      this.verificacaoTelefone.ids_cadastrados = []
      this.verificacaoTelefone.cadastrado = false
      this.verificacaoTelefone.quantidade = 0
     }
    }
  },
  beforeMount () {
    if (this.empresa_selecionada) {
      this.pegarEmpresa()
      this.pegarEmpresasIntegradoras()
      this.pegarEmpresaAutomacao()
      if (this.empresa_selecionada.tipo_empresa === 9) {
        this.sindicato = this.empresa_selecionada.rede_sindicato
        this.pegarSindicatos()
      }
      this.pegarProjetosFirebase()
    }
  },
  methods: {
    pegarSindicatos () {
        this.$store.dispatch('pegarTodasRedes', { tipo_rede: 1, notPaged: true }).then(json => {
            this.sindicatos = json
        })
    },
    pegarProjetosFirebase () {
      this.$store.dispatch('projetosFirebase', {
        filtros: { paginate: false }
      }).then(json => {
        let items = json.results || json
        this.projetosFirebase = items.map(projeto => ({
          id: projeto.id,
          codigo: projeto.codigo,
          nome: projeto.nome_rede || projeto.nome_empresa || projeto.codigo
        }))
      })
    },
    selecionarSindicato () {
      this.$store.dispatch('VincularSincicato', { id_rede: this.sindicato, cnpj: this.empresa.cnpj })
    },
    selecionarIntegradora () {
      const data = {
        body: {
          empresa_proprietaria: this.integradora_cnpj ? this.integradora_cnpj : null,
          empresa_integrada: this.empresa.cnpj
        }
      }
      if (this.empresa.integrador) {
        data.id = this.empresa.integrador.id
        data.method = this.integradora_cnpj ? 'PUT' : 'DELETE'
      } else data.method = 'POST'
      this.$store.dispatch('integrador', data).then(() => {
        this.pegarEmpresa()
      })
    },
    pegarEmpresasIntegradoras () {
      this.$store.dispatch('procurarEmpresasPorAdm', {
        filtros: { tipo_empresa: 8 }
      }).then(json => {
        this.empresas_integradora = json
      })
    },
    pegarEmpresa () {
      this.$store.dispatch('pegarEmpresa', this.empresa_selecionada.cnpj).then(json => {
        this.empresa = json
        if (this.empresa.taxa_por_abastecimento !== null) {
          this.taxa_abastecimeto = true
        }
        if (this.empresa.taxa_por_abastecimento_carteira !== null) {
          this.taxa_abastecimeto_carteira = true
        }
        if (this.empresa.taxa_por_veiculo !== null) {
          this.taxa_por_veiculo = true
          this.valor_taxa_veiculo = this.empresa.taxa_por_veiculo
        }
        if (this.empresa.valor_assinatura !== null) {
          this.tem_mensalidade = true
          this.valor_mensalidade = this.empresa.valor_assinatura
        }

        if (this.empresa.taxa_recebimento_cliente) {
          this.tem_taxa_recebimento_cliente = true
        }

        if (this.empresa.taxa_recebimento_empresa) {
          this.tem_taxa_recebimento_empresa = true
        }

        if (this.empresa.taxa_recebimento_carteira_cliente) {
          this.tem_taxa_recebimento_carteira_cliente = true
        }

        if (this.empresa.taxa_recebimento_carteira_empresa) {
          this.tem_taxa_recebimento_carteira_empresa = true
        }

        if (json.data_ultimo_faturamento_apetrus) {
          this.data_fatura = json.data_ultimo_faturamento_apetrus
          this.data_fatura_formated = json.data_ultimo_faturamento_apetrus
          .split('-')
          .reverse()
          .join('/')
        }
        if (this.empresa.programa_doacao === null) {
          this.empresa.programa_doacao = {
            valor_doacao: '0,00',
            ativo_apetrus: false
          }
        } else {
          this.valor_doacao = this.empresa.programa_doacao.valor_doacao
        }
        this.empresa.gerar_boleto = json.gerar_boleto
        if (json.integrador) {
          this.integradora_cnpj = json.integrador.empresa_proprietaria
        }
        if (json.automacao) {
          this.cnpj_empresa_automacao = json.automacao
        }
      })
    },
    editarEmpresa () {
      this.rendering = false
      if (this.step === 2) {
        this.$store.dispatch('atualizarPessoa', this.empresa.administrador).then(() => {
          this.pegarEmpresa()
          this.$emit('pegarEmpresas')
          this.$emit('success', 'Administrador da empresa foi atualizado com sucesso.')
          this.rendering = true
          this.$emit('carregar')
        }).catch(() => {
          this.$emit('error', 'Não foi possível atualizar administrador da empresa.')
        })
      } else {
        this.$store.dispatch('editarEmpresa', {
          ...this.empresa,
          programa_doacao: this.empresa.programa_doacao.ativo_apetrus ? this.empresa.programa_doacao : null
        }).then(() => {
          this.pegarEmpresa()
          this.$emit('pegarEmpresas')
          this.$emit('success', 'Empresa atualizada com sucesso.')
          this.rendering = true
          this.$emit('carregar')
        }).catch(() => {
          this.pegarEmpresa()
          this.$emit('error', 'Não foi possível atualizar empresa.')
        })
      }
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: this.empresa.administrador.id_pessoa,
        telefone: this.empresa.administrador.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    },
    pegarEmpresaAutomacao () {
      this.$store.dispatch('procurarEmpresasPorAdm', {
        filtros: { tipo_empresa: 3 }
      }).then(json => {
        this.empresas_automacao = json
      })
    },
    selecionarAutomacao () {
      this.$store.dispatch('automacaoEmpresa', {
        cnpj_empresa: this.cnpj_empresa_automacao ? this.cnpj_empresa_automacao : null,
        cnpj_empresa_integrada: this.empresa.cnpj
      }).then(() => {
        this.pegarEmpresa()
      })
    }
  }
}
</script>
